import React from 'react';
import './styles.scss';
import { UserAuth } from '../../../../../types/user';
import { useQuery } from '@tanstack/react-query';
import { getRnB } from '../../../../../services/profile';
import { NumberFormatter, Skeleton, Text } from '@mantine/core';
import { useHistory } from 'react-router-dom';

interface ProfileUserProps {
  user: UserAuth;
}

const ProfileUser: React.FC<ProfileUserProps> = ({ user }) => {
  const router = useHistory();
  const fetchedDataProfileRnB = useQuery({
    queryKey: [`profileRnB`, user?.email],
    queryFn: () => getRnB('', ''),
    enabled: !!user?.email
  });
  const { data: rnb, isLoading } = fetchedDataProfileRnB;

  return (
    <div className="container-profile-user">
      <h3 className="m-0">{user?.fullName}</h3>
      <div className="wrapper-job-title">
        <h5 className="m-0">{user?.position}</h5>
        <p className="m-0">{user?.binusianId}</p>
        <p className="m-0">{user?.businessUnitName}</p>
      </div>

      {isLoading && <Skeleton height={20} width={'50%'} />}

      {/* =========> DI COMMENT BENTAR, REQUEST DARI PAK ARIEF 2 Juli 2024 <========= */}
      {/* {!isLoading && (
        <Text
          className="text-sm-semibold"
          style={{
            cursor: 'pointer'
          }}
          onClick={() => router.push('/profile')}
        >
          <NumberFormatter
            value={Number(rnb?.data?.totalPoints || 0)}
            suffix={` Point${
              Number(rnb?.data?.totalPoints || 0) > 1 ? 's' : ''
            }`}
            thousandSeparator="."
            decimalSeparator=","
          />
        </Text>
      )} */}
      {/* <h6 className='m-0'>{user?.point || 0} {user?.point && user.point > 1 ? 'Points' : 'Point'}</h6> */}
    </div>
  );
};

export default ProfileUser;
